export const faqs = [
  {
    id: "faq-1",
    question: "福利导航网站上的福利信息都是免费的吗？",
    answer: "福利导航聚合的福利资源大部分都是免费的，包括优惠券、免费试用、积分兑换等。部分资源可能需要满足特定条件（如学生认证、会员等级等）才能领取。我们会在每篇文章中明确标注福利的获取条件，确保您清楚了解。",
  },
  {
    id: "faq-2",
    question: "福利信息的更新频率是怎样的？",
    answer: "我们的编辑团队每天都会监控各大平台的福利动态，确保信息及时更新。热门福利和限时活动会在第一时间推送，常规福利信息每周至少进行一次全面核查，保障信息的准确性和时效性。",
  },
  {
    id: "faq-3",
    question: "如何快速找到我需要的福利？",
    answer: "您可以通过以下三种方式快速定位目标福利：1）使用首页顶部的搜索功能输入关键词检索；2）通过首页的分类导航按类别浏览；3）在分类页面使用侧边栏筛选器按类别和标签精准查找。",
  },
  {
    id: "faq-4",
    question: "领取福利时遇到问题怎么办？",
    answer: "如果在领取福利过程中遇到任何问题，您可以先查看文章底部的常见问题说明。如果问题仍未解决，欢迎通过关于我们页面的联系方式与我们取得联系，我们的客服团队会在24小时内回复您。",
  },
  {
    id: "faq-5",
    question: "福利导航网站需要注册账号吗？",
    answer: "不需要。福利导航是一个完全开放的信息聚合平台，所有福利信息和文章均可免费浏览，无需注册账号。我们致力于为用户提供最低门槛的福利信息获取体验。",
  },
  {
    id: "faq-6",
    question: "我可以推荐福利资源给你们吗？",
    answer: "当然可以！我们非常欢迎用户推荐优质的福利资源。您可以通过关于我们页面的联系方式提交推荐，我们的编辑团队会进行审核，审核通过后会及时添加到网站上并注明推荐来源。",
  },
  {
    id: "faq-7",
    question: "网站上的福利是否适用于所有地区？",
    answer: "大部分线上福利（如电商优惠券、会员权益、免费试用等）全国通用。但部分地方性补贴政策（如交通补贴、住房补贴等）可能有地域限制，我们会在文章中明确标注适用范围，请留意查看。",
  },
  {
    id: "faq-8",
    question: "如何不错过最新的福利信息？",
    answer: "建议您将福利导航加入浏览器收藏夹，定期访问查看最新内容。我们也会在首页的「最新福利」板块实时更新近期发布的福利信息，方便您第一时间获取。",
  },
];